import React from 'react';

import { TutorialCashOutHeader } from './tutorialCashOutHeader';
import { TutorialCashOutButton } from './tutorialCashOutButton';

export const TutorialCashOutStates = ({ tutorialData, t, tutorialStep }) => {
  return (
    <div className='fighters-game-betting'>
      <div className='wrapper'>
        <div className='parent-inner'>
          <div className='bet-holder cash-out'>
            <TutorialCashOutHeader tutorialData={tutorialData} t={t} tutorialStep={tutorialStep} />
            <TutorialCashOutButton tutorialData={tutorialData} t={t} tutorialStep={tutorialStep} />
          </div>
        </div>
      </div>
    </div>
  );
};
